import type { NextPage } from 'next';
import ForgotPassword from '@containers/ForgotPasswordPage';
import Head from 'next/head';

const ForgotPasswordPage: NextPage = () => {
  return (
    <>
      <Head>
        <title>Forgot Password - The Cumin Club</title>
      </Head>
      <ForgotPassword />
    </>
  );
};

export default ForgotPasswordPage;
